import * as Types from '../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ClientsPageQueryVariables = Types.Exact<{
  first?: Types.Maybe<Types.Scalars['Int']>;
  last?: Types.Maybe<Types.Scalars['Int']>;
  search?: Types.Maybe<Types.Scalars['String']>;
  orderBy?: Types.Maybe<Types.Scalars['String']>;
  hasUpcomingBooking?: Types.Maybe<Types.Scalars['Boolean']>;
  hasRemainingSessions?: Types.Maybe<Types.Scalars['Boolean']>;
  matchStatus?: Types.Maybe<Types.Scalars['String']>;
  lastWho5Date?: Types.Maybe<Types.Scalars['String']>;
  appInstalled?: Types.Maybe<Types.Scalars['Boolean']>;
  companies?: Types.Maybe<Types.Scalars['String']>;
  before?: Types.Maybe<Types.Scalars['String']>;
  after?: Types.Maybe<Types.Scalars['String']>;
}>;


export type ClientsPageQuery = (
  { __typename?: 'Query' }
  & { clients?: Types.Maybe<(
    { __typename?: 'ClientSummaryNodeConnection' }
    & Pick<Types.ClientSummaryNodeConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfo, 'startCursor' | 'endCursor'>
    ), edges: Array<Types.Maybe<(
      { __typename?: 'ClientSummaryNodeEdge' }
      & Pick<Types.ClientSummaryNodeEdge, 'cursor'>
      & { node?: Types.Maybe<(
        { __typename?: 'ClientSummaryNode' }
        & Pick<Types.ClientSummaryNode, 'appInstalled' | 'companyName' | 'id' | 'isCompanyHpiEnabled' | 'isCompanyPsychiatryEnabled' | 'lastVisit' | 'lastWho5Score' | 'matchStatus' | 'memberEmail' | 'memberFirstName' | 'memberInsuranceStatus' | 'memberLastName' | 'memberName' | 'memberUuid' | 'nextVisit' | 'phq9SelfharmScore' | 'visitsCovered' | 'visitsRemaining' | 'visitsUsed' | 'coachingVisitsToReportCount'>
      )> }
    )>> }
  )> }
);


export const ClientsPageDocument = gql`
    query ClientsPage($first: Int, $last: Int, $search: String, $orderBy: String, $hasUpcomingBooking: Boolean, $hasRemainingSessions: Boolean, $matchStatus: String, $lastWho5Date: String, $appInstalled: Boolean, $companies: String, $before: String, $after: String) {
  clients(
    first: $first
    last: $last
    search: $search
    orderBy: $orderBy
    hasUpcomingBooking: $hasUpcomingBooking
    hasRemainingSessions: $hasRemainingSessions
    matchStatus: $matchStatus
    lastWho5Date: $lastWho5Date
    appInstalled: $appInstalled
    companies: $companies
    before: $before
    after: $after
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        appInstalled
        companyName
        id
        isCompanyHpiEnabled
        isCompanyPsychiatryEnabled
        lastVisit
        lastWho5Score
        matchStatus
        memberEmail
        memberFirstName
        memberInsuranceStatus
        memberLastName
        memberName
        memberUuid
        nextVisit
        phq9SelfharmScore
        visitsCovered
        visitsRemaining
        visitsUsed
        coachingVisitsToReportCount
      }
    }
  }
}
    `;
export type ClientsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientsPageQuery, ClientsPageQueryVariables>, 'query'>;

    export const ClientsPageComponent = (props: ClientsPageComponentProps) => (
      <ApolloReactComponents.Query<ClientsPageQuery, ClientsPageQueryVariables> query={ClientsPageDocument} {...props} />
    );
    
export type ClientsPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ClientsPageQuery, ClientsPageQueryVariables>
    } & TChildProps;
export function withClientsPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientsPageQuery,
  ClientsPageQueryVariables,
  ClientsPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ClientsPageQuery, ClientsPageQueryVariables, ClientsPageProps<TChildProps, TDataName>>(ClientsPageDocument, {
      alias: 'clientsPage',
      ...operationOptions
    });
};

/**
 * __useClientsPageQuery__
 *
 * To run a query within a React component, call `useClientsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsPageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      hasUpcomingBooking: // value for 'hasUpcomingBooking'
 *      hasRemainingSessions: // value for 'hasRemainingSessions'
 *      matchStatus: // value for 'matchStatus'
 *      lastWho5Date: // value for 'lastWho5Date'
 *      appInstalled: // value for 'appInstalled'
 *      companies: // value for 'companies'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useClientsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientsPageQuery, ClientsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientsPageQuery, ClientsPageQueryVariables>(ClientsPageDocument, options);
      }
export function useClientsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientsPageQuery, ClientsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientsPageQuery, ClientsPageQueryVariables>(ClientsPageDocument, options);
        }
export type ClientsPageQueryHookResult = ReturnType<typeof useClientsPageQuery>;
export type ClientsPageLazyQueryHookResult = ReturnType<typeof useClientsPageLazyQuery>;
export type ClientsPageQueryResult = ApolloReactCommon.QueryResult<ClientsPageQuery, ClientsPageQueryVariables>;